import { usePollInterval } from "@src/lib/hooks/usePollInterval";
import { useMemo } from "react";
import {
  CommentThreadFragment,
  useGetCourseCommentThreadsQuery,
} from "../build/comments/Comment.generated";

type Return = {
  commentThreads: CommentThreadFragment[];
  totalCommentCount: number;
};

type Args = {
  courseVersionId?: number;
};

const useCourseCommentThreads = (args: Args): Return => {
  const commentThreadsPollInterval = usePollInterval(3000);
  const { data: commentThreadsData, previousData: commentThreadsDataPrev } =
    useGetCourseCommentThreadsQuery({
      skip: !args.courseVersionId,
      pollInterval: commentThreadsPollInterval,
      variables: {
        courseVersionId: args.courseVersionId || -1,
      },
    });
  const commentThreads = useMemo(
    () =>
      commentThreadsData?.AdminCommentThreads ||
      commentThreadsDataPrev?.AdminCommentThreads ||
      [],
    [
      commentThreadsData?.AdminCommentThreads,
      commentThreadsDataPrev?.AdminCommentThreads,
    ],
  );
  const totalCommentCount = useMemo(() => {
    return commentThreads.reduce((acc, thread) => {
      return acc + thread.comments.length;
    }, 0);
  }, [commentThreads]);
  return useMemo(() => {
    return {
      commentThreads,
      totalCommentCount,
    };
  }, [commentThreads, totalCommentCount]);
};

export default useCourseCommentThreads;
